import OMovieSlot from './o-movie-slot.vue';

export default OMovieSlot;